import React from 'react'
import ImageWrapper from '../ImageWrapper'
import AniLink from "gatsby-plugin-transition-link/AniLink"


const TestCard = ({ TestType, TestName,TestUrl, Duration }) => {
  return (
      <>
          <div className="test_card_item">
              <div className="test_card_first">
                  {TestType === 'Writing' ? <ImageWrapper ImgUrl={"https://s3.us-east-2.wasabisys.com/ufaber-lms/files/28f8e9c3e08da29cf9ae88f422a413e3.svg"} /> : TestType === 'Speaking' ? <ImageWrapper ImgUrl={"https://s3.us-east-2.wasabisys.com/ufaber-lms/files/5567a6c9787be62af8a04e6ddde64512.svg"} /> : TestType === 'Reading' ? <ImageWrapper ImgUrl={"https://s3.us-east-2.wasabisys.com/ufaber-lms/files/64d5540530eb9d147e9734ad6b56d91f.svg"} />: <ImageWrapper ImgUrl={"http://s3.us-east-2.wasabisys.com/ufaber-lms/files/a6bd24d7990843e1aa59de2d4d56232d.168583168490845"} />}
                  <span className="test_card_quiz_type_detail">
                      <p>{TestType}</p>
                  </span>
              </div>
              <div className="test_card_second">
                  <p>{TestName} .</p>
              </div>
              <div className="test_card_third">
                  <div className="test_card_other_details">
                      <span className="test_card_questions">
                          <p>40 Questions</p>
                      </span>
                      <span className="test_card_vertical_line"></span>
                      <span className="test_card_duration">
                          <p>{Duration} Minutes</p>
                      </span>
                          </div>
                  <AniLink fade to={TestUrl}>
                            <button className="test_card_btn">
                                <ImageWrapper ImgUrl={"http://s3.us-east-2.wasabisys.com/ufaber-lms/files/7924825b0b2eaa14806e02b994fea30e.168583337574545"} />
                            </button> 
                </AniLink>
              </div>
          </div>
      </>
  )
}

export default TestCard